var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_9736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5519 3.51501C15.8649 -1.17199 8.26691 -1.17199 3.58091 3.51501C-1.10509 8.20101 -1.10509 15.799 3.58091 20.485C8.26691 25.171 15.8649 25.171 20.5519 20.485C25.2189 15.791 25.2189 8.21001 20.5519 3.51501ZM16.7589 15.293C17.1499 15.684 17.1499 16.316 16.7589 16.707C16.5639 16.902 16.3079 17 16.0519 17C15.7959 17 15.5399 16.902 15.3449 16.707L12.0519 13.414L8.75891 16.707C8.56391 16.902 8.30791 17 8.05191 17C7.79591 17 7.53991 16.902 7.34491 16.707C6.95391 16.316 6.95391 15.684 7.34491 15.293L10.6379 12L7.34491 8.70701C6.95391 8.31601 6.95391 7.68401 7.34491 7.29301C7.73591 6.90201 8.36791 6.90201 8.75891 7.29301L12.0519 10.586L15.3449 7.29301C15.7359 6.90201 16.3679 6.90201 16.7589 7.29301C17.1499 7.68401 17.1499 8.31601 16.7589 8.70701L13.4659 12L16.7589 15.293Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_9736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0527344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCloseButton);
export default __webpack_public_path__ + "static/media/newCloseButton.649089f0e28468341af0372a4a12d19c.svg";
export { ForwardRef as ReactComponent };